export const getReserveWithGoogleToken = (): string | undefined => {
  const [, ...values] = (
    (window?.document?.cookie || '')
      .split('; ')
      .find((row) => row.startsWith('_rwg_token=')) || ''
  ).split('=');
  return values?.length > 0 ? values.join('=') : undefined;
};
